import { Alert, Typography } from 'antd'
import { memo, useMemo } from 'react'
import styled from 'styled-components'

import { TicketGroupSelect, TicketGroupSelectProps } from './TicketGroupSelect'

const AlertContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const { Text } = Typography

type TicketGroupBannerProps = TicketGroupSelectProps

export const TicketGroupBanner = memo(
  ({ groups, selectedGroupId, ...rest }: TicketGroupBannerProps) => {
    const selectedGroup = useMemo(
      () => groups.find((group) => group.id === selectedGroupId),
      [groups, selectedGroupId]
    )

    const message = useMemo(
      () =>
        selectedGroup ? (
          <>
            Showing tickets for <Text strong>{selectedGroup.title}</Text>
          </>
        ) : selectedGroupId === null ? (
          'Showing ungrouped tickets'
        ) : (
          'Showing all tickets'
        ),
      [selectedGroup, selectedGroupId]
    )

    const messageContent = useMemo(
      () => (
        <AlertContent>
          <span>{message}</span>
          <TicketGroupSelect
            groups={groups}
            selectedGroupId={selectedGroupId}
            {...rest}
          />
        </AlertContent>
      ),
      [groups, message, rest, selectedGroupId]
    )

    return <Alert type='info' showIcon title={messageContent} />
  }
)

TicketGroupBanner.displayName = 'TicketGroupBanner'
